'use client'

import React from "react";
import Image from "next/image";
import Link from  "next-intl/link";
import Logo from "@/img/logo.svg";
import Title from "@/components/account/title";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from "@/components/Button"
import { faDoNotEnter } from "@fortawesome/pro-solid-svg-icons";

export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    return (
        <html>
            <body>
                <section className="w-screen h-screen overflow-hidden relative">
                    <div className="h-screen w-screen overflow-y-auto relative z-10">
                        <header className="py-6 lg:py-10 px-4">
                            <div className="container flex items-center justify-start w-full">
                                <div className="flex items-ceter">
                                    <div className="max-w-[146px] lg:max-w-full">
                                        <Link href="/" title="Home">
                                            <Image src={Logo} alt="Carecoins" />
                                        </Link>
                                    </div>
                                </div>  
                            </div>
                        </header>
                        <div className="text-center mt-10">
                            <div className="text-center mb-20 max-w-[700px] mx-auto">
                                <FontAwesomeIcon icon={faDoNotEnter} className={`text-7xl mb-6 text-primary`} />
                                <Title>Error - something seems to have broken!</Title>
                                <p className="mt-6 mb-12">Let&apos;s get back on track</p>
                                <div onClick={() => reset()}>
                                    <Button  label={"Back to home"} type="button" class="inline-flex text-white" />
                                </div>
                            </div>
                        </div>
                    </div>
                
                </section>
            </body>
        </html>
    )
}